import { config } from "@/config";
export const DesplegableService = {
    async getDesplegableById(id) {
        const response = await fetch(`${config.API_URL}/api/NombresAtributos/${id}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener el desplegable con id ${id}`);
        }
        const result = await response.json();
        return result.data;
    },
    async getAllDesplegables() {
        const response = await fetch(`${config.API_URL}/api/NombresAtributos`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener todos los desplegables");
        }
        const result = await response.json();
        if (!result.data || !Array.isArray(result.data)) {
            console.error('Se esperaba un array de desplegables en la propiedad "data" pero se recibió:', result);
            return [];
        }
        return result.data;
    },
    async addDesplegable(desplegable) {
        const response = await fetch(`${config.API_URL}/api/NombresAtributos`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(desplegable),
        });
        if (!response.ok) {
            let errorMessage = "Error al agregar el desplegable";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) { }
            throw new Error(errorMessage);
        }
    },
    async updateDesplegable(id, desplegable) {
        const response = await fetch(`${config.API_URL}/api/NombresAtributos/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(desplegable),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar el desplegable");
        }
    },
    async deleteDesplegable(id) {
        const response = await fetch(`${config.API_URL}/api/NombresAtributos/${id}`, {
            method: "DELETE",
        });
        if (!response.ok) {
            let errorMessage = "Error al eliminar el desplegable";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) { }
            throw new Error(errorMessage);
        }
    },
    async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/NombresAtributos/${id}/toggle-activo`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok) {
            throw new Error("No se pudo cambiar el estado del desplegable");
        }
    },
};
